import React from 'react';

import { createPortal } from 'react-dom';

import { BLOCK_SCENES } from './config';
import { useChangingScene } from './functions';
import s from './index.module.css';
import BlocksMenu from './Scenes/BlocksMenu';
import ContentBlockDropdown from './Scenes/ContentBlockDropdown';
import { IframeContainer } from './Scenes/IframeContainer';
import { IMenuProps } from './types';

function Menu({ anchorRef, onAdd, onClose, isInsideAccordion }: IMenuProps) {
  const { scene, handleChangeScene } = useChangingScene();

  return createPortal(
    <div className={s.block}>
      <div className={s.backDrop} onClick={onClose} />
      {scene === BLOCK_SCENES.DEFAULT && (
        <BlocksMenu
          anchorRef={anchorRef}
          handleChangeScene={handleChangeScene}
          onAdd={onAdd}
          onClose={onClose}
          isInsideAccordion={isInsideAccordion}
        />
      )}
      {scene === BLOCK_SCENES.CONTENT_BLOCK && (
        <ContentBlockDropdown anchorRef={anchorRef} onAdd={onAdd} onClose={onClose} />
      )}
      {scene === BLOCK_SCENES.IFRAME_CONFIG && (
        <IframeContainer anchorRef={anchorRef} onAdd={onAdd} onClose={onClose} />
      )}
    </div>,
    document.body,
  );
}

export default Menu;
